<template>
  <div>ไม่สามารถดำเนินการ <b>กรุณาพักบอทก่อน </b></div>
</template>

<script>
export default {
  name: "notification-template",
};
</script>
